import { FunctionComponent } from "react";
import { RegulatoryHeader as RegulatoryHeaderComponent } from "./snowflakes/RegulatoryHeader/RegulatoryHeader.web";
import { ComponentProps } from "./props";

const RegulatoryHeader: FunctionComponent<ComponentProps> = ({ regulatorySections, jurisdiction }) =>
  regulatorySections?.length ? (
    <RegulatoryHeaderComponent regulatorySections={regulatorySections} jurisdiction={jurisdiction} />
  ) : null;

export default RegulatoryHeader;
